import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import InputSelect from '../../components/InputGroup/InputSelect';
import MobileInput from '../../components/InputGroup/MobileInput';
import { ReactComponent as InfoIcon } from '../../assets/plus_icon/incentive_pending.svg';
import PhoneInput from 'react-phone-input-2';
import { ALL_REGEX } from '../../config/static';
import { ReactComponent as LeftArrowIcon } from '../../assets/plus_icon/leftArrow.svg';
import { getCities } from '../../services/private/csv.service';
import AsyncCreatableSelect from 'react-select/async-creatable';
const customStyles = {
    control: (base, state) => ({
        ...base,
        boxShadow: "none",
        borderColor: '#ced4da',
        // backgroundColor: '#FAFAFB',
        minHeight: '54px',
        minWidth: '100%',
        borderRadius: '8px',
        fontSize: '18px',
        fontWeight: '400',
        cursor: 'pointer',
        '&:focus': { borderColor: '#0062ff' },
    }),
    option: (styles, state) => ({
        ...styles,
        fontSize: '14px',
        cursor: 'pointer',
        backgroundColor: state.isSelected ? "#f1f1f5" : styles.color,
        color: '#44444f',
        zIndex: 99,
        "&:hover": {
            color: "#44444f",
            backgroundColor: "#f1f1f5"
        },
    }),
};

const InfoList = [
    {
        label: 'Event',
        value: 'Event'
    },
    {
        label: 'Website',
        value: 'Website'
    },
    {
        label: 'SMS',
        value: 'SMS'
    },
    {
        label: 'WhatsApp',
        value: 'WhatsApp'
    },
    {
        label: 'Facebook/Instagram',
        value: 'Facebook/Instagram'
    },
    {
        label: 'Newspaper',
        value: 'Newspaper'
    },
    // {
    //     label: 'Channel Partner',
    //     value: 'Channel Partner'
    // },
    {
        label: 'Direct Walking',
        value: 'Direct Walking'
    },
    {
        label: 'Hoarding',
        value: 'Hoarding'
    },
    {
        label: 'PreSales',
        value: 'PreSales'
    },
    {
        label: 'Reference',
        value: 'Reference'
    },
    {
        label: 'Other',
        value: 'Other'
    }
]

const CustomerDetails = ({
    setChannelPartner,
    isWithCP,
    detail,
    handleChangeDetail,
    investement,
    setInvestment,
    purpose,
    setPurpose,
    preference,
    setPrefrence,
    altMobile,
    setAltMobile,
    mobile,
    setMobile,
    setAboutProject,
    aboutProject,
    possessionPreference,
    setPossessionPreference,
    others,
    setOthers,
    referralMobile,
    setReferralMobile,
    referralName,
    setReferralName,
    society,
    setSociety,
    flatNo,
    setFlatNo,
    city,
    setCity
}) => {
    const [error, setError] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [mobileError, setMobileError] = useState(false);
    const [referenceMobileError, setReferenceMobileError] = useState(false);

    useEffect(() => {
        if (isWithCP) {
            setAboutProject('')
            setReferralMobile('')
            setReferralName('')
            setSociety('');
            setFlatNo('');
            setOthers()
        }
    }, [isWithCP]);

    useEffect(() => {
        const unloadCallback = (event) => {
            event.preventDefault();
            event.returnValue = "";
            return "";
        };

        // window.addEventListener("popstate", handleBackButton);
        window.addEventListener("beforeunload", unloadCallback);

        return () => {
            // window.removeEventListener("popstate", handleBackButton);
            window.removeEventListener("beforeunload", unloadCallback);
        };

    }, []);

    const handleSubmit = () => {
        // All fields Error check
        if (!mobile || !detail.name || !detail.email || (!isWithCP && !aboutProject) || (!isWithCP && aboutProject === 'Reference' && (!referralName || !referralMobile))) {
            setError(true);
            if ((!isWithCP && !aboutProject) || (aboutProject === 'Reference' && (!referralName || !referralMobile))) {
                document.getElementById('source').scrollIntoView({
                    behavior: 'smooth', block: "end", inline: "nearest"
                });
            } else {
                document.getElementById('customer-form').scrollIntoView({
                    behavior: "smooth"
                });
            }
            return
        } else {
            setError(false)
        }

        // Email Error check
        if (!ALL_REGEX.EMAIL.test(detail.email)) {
            setEmailError(true);
            return;
        } else {
            setEmailError(false)
        }
        // // Mobile Error check
        if (mobile.length < 12) {
            setMobileError(true);
            return;
        } else {
            setMobileError(false)
        }
        // Error check for source field referral option
        if ((!isWithCP && aboutProject === 'Reference' && referralMobile) && referralMobile.length < 12) {
            document.getElementById('source').scrollIntoView({
                behavior: 'smooth', block: "end", inline: "nearest"
            });
            setReferenceMobileError(true);
            return;
        } else {
            setMobileError(false)
        }

        if (isWithCP) {
            setChannelPartner('4')
        } else {
            setChannelPartner('5')
        }
    }

    const loadOptions = (city) => {
        return getCities(city)
            .then((res) => {
                if (res.data.status === 200) {

                    const cities = res.data?.data.map((city) => {
                        return {
                            label: city.name,
                            value: city.name
                        }
                    });
                    return cities;
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }

    return (
        <div className=' mx-auto overflow-visible'>
            <div className='flex items-center sm:justify-center bg-white rounded-xl !py-6 md:!py-12 z-10 !sticky !-top-6'>
                <button className='flex items-center static ml-4 sm:ml-0  sm:absolute sm:left-5 md:left-10 ' onClick={() => setChannelPartner('2')}>
                    <LeftArrowIcon className='stroke-black800 rotate-180 mr-1' /> <span className='hidden sm:inline-block'>Back</span>
                </button>
                <p className='flex flex-col sm:flex-row text-lg sm:text-2xl font-semibold mb-0 !ml-4 !sm:ml-0'>
                    Customer {isWithCP ? 'with CP' : 'Self Check-in'} - <span className='text-[#2064FA] ml-1'> Coral Park</span>
                </p>
            </div>
            <div className=' bg-white rounded-xl !mt-6 !p-5 md:!p-10' id='customer-form'>
                <div className='sm:!mt-6 space-y-4 sm:space-y-6'>
                    <div className='sm:!text-xl text-lg font-semibold text-gray800'>Basic Details</div>
                    <div className={` font-medium position-relative flex flex-col`}>
                        <label className='sm:!text-lg text-base !mb-3 '>Mobile No.<sup className='text-red'>*</sup></label>

                        <PhoneInput
                            inputClass={'border !w-full focus:outline-none focus:border-primary rounded-xl !text-gray800 !font-medium text-input !h-[38px] sm:!h-[54px] text-sm sm:!text-base sm:placeholder:!text-base placeholder:!text-sm  !py-2 sm:!py-3'}
                            // containerClass={classname}
                            country={'in'}
                            value={mobile}
                            countryCodeEditable={false}
                            enableSearch={true}
                            disableSearchIcon={true}
                            onChange={phone => {
                                setMobile(phone)
                            }}
                            disabled={true}
                        />
                        <div className=' flex items-center gap-2 sm:!text-sm text-xs text[#314056] !mt-4'>
                            <span><InfoIcon /></span> Make sure this is your registered mobile no. on whatsapp.
                        </div>
                        {error && !mobile && (
                            <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Customer Mobile No.</div>

                        )}
                        {
                            mobileError && mobile && <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Valid Mobile No.</div>
                        }

                    </div>
                    <div className='w-full flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6'>
                        <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>Name<sup className='text-red'>*</sup></label>
                            <input
                                className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                type={"text"}
                                name='name'
                                value={detail.name}
                                onChange={handleChangeDetail}
                                placeholder={'Enter First Name'}
                            />
                            {error && !detail.name && (
                                <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Customer Name</div>

                            )}
                        </div>
                        {/* <div className={`flex flex-col font-medium relative w-full md:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>Last Name</label>
                            <input
                                className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                type={"text"}
                                placeholder={'Enter Last Name'}
                                name='lastName'
                                value={detail.lastName}
                                onChange={handleChangeDetail}
                            />
                        </div> */}
                        <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>E-Mail<sup className='text-red'>*</sup></label>
                            <input
                                className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                type={"text"}
                                placeholder={'Enter E-Mail'}
                                name='email'
                                value={detail.email}
                                onChange={handleChangeDetail}
                            />
                            {error && !detail.email && (
                                <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Customer Email</div>
                            )}
                            {emailError && detail.email && (
                                <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Valid Email</div>
                            )}

                        </div>
                    </div>
                    <div className='!border !border-dashed '></div>
                    <div className='w-full flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6'>
                        <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>Alternate No.</label>
                            <PhoneInput
                                inputClass={'border !w-full focus:outline-none focus:border-primary !text-gray800 !font-medium rounded-xl text-input !h-[38px] sm:!h-[54px] text-sm sm:!text-base sm:placeholder:!text-base placeholder:!text-sm  !py-2 sm:!py-3'}
                                // containerClass={classname}
                                country={'in'}
                                value={altMobile}
                                countryCodeEditable={false}
                                enableSearch={true}
                                disableSearchIcon={true}
                                onChange={phone => {
                                    setAltMobile(phone)
                                }}
                            />
                        </div>

                        <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>Address </label>
                            <input
                                className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                type={"text"}
                                placeholder={'Enter Address '}
                                name='address'
                                value={detail.address}
                                onChange={handleChangeDetail}
                            />
                            {/* {error && !detail.address && (
                                <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Customer Address</div>

                            )} */}
                        </div>
                    </div>
                    <div className='w-full flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6'>
                        <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>City</label>
                            <AsyncCreatableSelect
                                cacheOptions
                                loadOptions={loadOptions}
                                customStyles={customStyles}
                                defaultOptions
                                placeholder='Search and Select City'
                                value={city ? { label: city, value: city } : ''}
                                styles={customStyles}
                                onChange={(e) => {
                                    console.log(e);
                                    setCity(e.value)
                                }}
                                menuPosition='fixed'
                            />
                        </div>
                        <div className={`flex flex-col font-medium relative w-full md:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>Pincode</label>
                            <input
                                className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                type={"number"}
                                placeholder={'Enter Pincode'}
                                name='pincode'
                                value={detail.pincode}
                                onChange={handleChangeDetail}
                            />
                        </div>

                    </div>
                    <div className='w-full flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6'>
                        <div className={`flex flex-col font-medium relative w-full md:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>Age</label>
                            <input
                                className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                type={"number"}
                                placeholder={'Enter Age'}
                                name='age'
                                value={detail.age}
                                onChange={handleChangeDetail}
                            />
                        </div>
                        <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>Company</label>
                            <input
                                className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                type={"text"}
                                placeholder={'Enter Company'}
                                name='company'
                                value={detail.company}
                                onChange={handleChangeDetail}
                            />
                        </div>
                    </div>

                    <div className='w-full flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6'>
                        <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>Profession  </label>
                            <input
                                className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                type={"text"}
                                placeholder={'Enter Profession'}
                                name='profession'
                                value={detail.profession}
                                onChange={handleChangeDetail}
                            />
                        </div>
                        <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>Designation</label>
                            <input
                                className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                type={"text"}
                                placeholder={'Enter Designation'}
                                name='designation'
                                value={detail.designation}
                                onChange={handleChangeDetail}
                            />
                        </div>
                    </div>
                    {/* <div className='w-full flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6'>
                        <div className={`flex flex-col font-medium relative w-full md:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>PAN Card</label>
                            <input
                                className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                type={"text"}
                                placeholder={'Enter PAN Card'}
                                name='panNo'
                                value={detail.panNo}
                                onChange={handleChangeDetail}
                            />
                        </div>
                        <div className={`flex flex-col font-medium relative w-full md:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>Aadhar Card</label>
                            <input
                                className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                type={"number"}
                                placeholder={'Enter Aadhar Card'}
                                name='aadhar'
                                value={detail.aadhar}
                                onChange={handleChangeDetail}
                            />
                        </div>
                    </div> */}

                    {!isWithCP && <div className='w-full flex items-center' id='source'>
                        <div className={`flex-col font-medium relative w-full hidden sm:flex`}>
                            <label className='sm:!text-lg text-base !mb-3 '>How did you find out about Coral Park Project?<sup className='text-red'>*</sup></label>
                            <Select
                                options={InfoList}
                                placeholder={'Select option'}
                                styles={customStyles}
                                value={aboutProject ? InfoList.find(i => i.value === aboutProject) : ''}
                                onChange={(value) => setAboutProject(value.value)}
                            />
                            {error && !aboutProject && (
                                <div className="text-red sm:!text-sm text-xs !mt-4">Please Select Project Source</div>

                            )}
                        </div>
                        <div className={` flex flex-col font-medium w-full sm:hidden`}>
                            <label className='sm:!text-lg text-base !mb-3 '>How did you find out about Coral Park Project?<sup className='text-red'>*</sup></label>
                            <InputSelect
                                options={InfoList}
                                placeholder={'Select option'}
                                value={aboutProject ? InfoList.find(i => i.value === aboutProject) : ''}
                                onChange={(value) => setAboutProject(value.value)}
                            />
                            {error && !aboutProject && (
                                <div className="text-red sm:!text-sm text-xs !mt-4">Please Select Project Source</div>

                            )}
                        </div>
                    </div>}
                    {aboutProject === 'Other' && <div className={`flex flex-col font-medium relative w-full`}>
                        <label className='sm:!text-lg text-base !mb-3 '>Other Source</label>
                        <input
                            className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                            type={"text"}
                            name='name'
                            value={others}
                            onChange={(e) => setOthers(e.target.value)}
                            placeholder={'Enter Other Source'}
                        />

                    </div>}
                    {
                        aboutProject === 'Reference' && <>
                            <div className='w-full flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6'>
                                <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                                    <label className='sm:!text-lg text-base !mb-3 '>Reference Name <sup className='text-red'>*</sup></label>
                                    <input
                                        className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                        type={"text"}
                                        placeholder={'Enter Reference Name '}
                                        name='address'
                                        value={referralName}
                                        onChange={(e) => setReferralName(e.target.value)}
                                    />
                                    {error && !referralName && (
                                        <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Reference Name</div>

                                    )}
                                </div>
                                <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                                    <label className='sm:!text-lg text-base !mb-3 '>Reference Mobile <sup className='text-red'>*</sup></label>
                                    <PhoneInput
                                        inputClass={'border !w-full focus:outline-none focus:border-primary !text-gray800 !font-medium rounded-xl text-input !h-[38px] sm:!h-[54px] text-sm sm:!text-base sm:placeholder:!text-base placeholder:!text-sm  !py-2 sm:!py-3'}
                                        // containerClass={classname}
                                        country={'in'}
                                        value={referralMobile}
                                        countryCodeEditable={false}
                                        enableSearch={true}
                                        disableSearchIcon={true}
                                        onChange={phone => {
                                            setReferralMobile(phone)
                                        }}
                                    />
                                    {error && !referralMobile && (
                                        <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Reference Mobile No</div>

                                    )}
                                    {
                                        referenceMobileError && referralMobile && <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Valid Mobile No.</div>
                                    }
                                </div>


                            </div>
                            <div className='w-full flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6'>
                                <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                                    <label className='sm:!text-lg text-base !mb-3 '>Society </label>
                                    <input
                                        className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                        type={"text"}
                                        placeholder={'Enter Society'}
                                        name='address'
                                        value={society}
                                        onChange={(e) => setSociety(e.target.value)}
                                    />
                                    {/* {error && !detail.address && (
                                <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Customer Address</div>

                            )} */}
                                </div>
                                <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                                    <label className='sm:!text-lg text-base !mb-3 '>Flat No</label>
                                    <input
                                        className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                        type={"text"}
                                        placeholder={'Enter Flat No'}
                                        name='address'
                                        value={flatNo}
                                        onChange={(e) => setFlatNo(e.target.value)}
                                    />
                                </div>

                            </div>
                        </>
                    }
                    <div className='!border !border-dashed !my-7 sm:!my-10'></div>
                    <div className='sm:!text-xl text-lg font-semibold text-gray800'>Inventory Preference</div>
                    <div className={` flex flex-col font-medium position-relative`}>
                        <label className='sm:!text-lg text-base !mb-3'>Possession Preference</label>
                        <div className='grid grid-cols-2 sm:flex gap-6'>
                            <div
                                className={`w-max rounded-full flex items-center text-lg border ${possessionPreference === 'Dec 2026' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                onClick={() => setPossessionPreference('Dec 2026')}
                            >
                                <input
                                    type="radio"
                                    name="possession"
                                    id=""
                                    value='Dec 2026'
                                    className='accent-white'
                                    checked={possessionPreference === 'Dec 2026'}
                                />
                                <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'> Dec 2026</label>
                            </div>
                            {/* <div
                                className={`w-max rounded-full flex items-center text-lg border ${possessionPreference === 'Dec 2027' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                onClick={() => setPossessionPreference('Dec 2027')}
                            >
                                <input
                                    type="radio"
                                    name="possession"
                                    id=""
                                    className='accent-white'
                                    value={'Dec 2027'}
                                    checked={possessionPreference === 'Dec 2027'}
                                />
                                <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>Dec 2027</label>
                            </div>
                            <div
                                className={`w-max rounded-full flex items-center text-lg border ${possessionPreference === 'Dec 2028' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                onClick={() => setPossessionPreference('Dec 2028')}
                            >
                                <input
                                    type="radio"
                                    name="possession"
                                    id=""
                                    className='accent-white'
                                    value={'Dec 2028'}
                                    checked={possessionPreference === 'Dec 2028'}
                                />
                                <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>Dec 2028</label>
                            </div> */}
                            {/* <div
                                className={`w-max rounded-full flex items-center text-lg border ${possessionPreference === 'Dec 29' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                onClick={() => setPossessionPreference('Dec 29')}
                            >
                                <input
                                    type="radio"
                                    name="possession"
                                    id=""
                                    className='accent-white'
                                    value={'Dec 29'}
                                    checked={possessionPreference === 'Dec 29'}
                                />
                                <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>Dec 29</label>
                            </div>
                            <div
                                className={`w-max rounded-full flex items-center text-lg border ${possessionPreference === 'Ready To Move' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                onClick={() => setPossessionPreference('Ready To Move')}
                            >
                                <input
                                    type="radio"
                                    name="possession"
                                    id=""
                                    className='accent-white'
                                    value={'Ready To Move'}
                                    checked={possessionPreference === 'Ready To Move'}
                                />
                                <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>Ready To Move</label>
                            </div> */}
                        </div>
                    </div>
                    {/* <div className={` flex flex-col font-medium position-relative`}>
                        <label className='sm:!text-lg text-base !mb-3'>Preferred Configuration</label>
                        <div className=' grid grid-cols-2 md:flex gap-6'>
                            <div
                                className={`w-max rounded-full flex items-center text-lg border ${preference === '2 BHK' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'} px-4 md:!px-6 py-2 md:!py-4`}
                                onClick={() => setPrefrence('2 BHK')}
                            >
                                <input
                                    type="radio"
                                    name="Preferred"
                                    id=""
                                    value={'2 BHK'}
                                    className='accent-white'
                                    checked={preference === '2 BHK'}
                                />
                                <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>2 BHK</label>
                            </div>                           
                            <div
                                className={`w-max rounded-full flex items-center text-lg border ${preference === '3 BHK' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                onClick={() => setPrefrence('3 BHK')}
                            >
                                <input
                                    type="radio"
                                    name="Preferred"
                                    id=""
                                    className='accent-white'
                                    value={'3 BHK'}
                                    checked={preference === '3 BHK'}
                                />
                                <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>3 BHK</label>
                            </div>                            
                        </div>
                    </div> */}

                    <div className={` flex flex-col font-medium position-relative`}>
                        <label className='sm:!text-lg text-base !mb-3'>How much you would like to invest?</label>
                        <div className='grid grid-cols-2 sm:flex gap-6'>
                            <div
                                className={`w-max rounded-full flex items-center text-lg border ${investement === '40L-70L' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                onClick={() => setInvestment('40L-70L')}
                            >

                                <input
                                    type="radio"
                                    name="invest"
                                    id=""
                                    className='accent-white'
                                    value={'40L-70L'}
                                    checked={investement === '40L-70L'}
                                />
                                <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>40L-70L</label>
                            </div>
                            <div
                                className={`w-max rounded-full flex items-center text-lg border ${investement === '70L-1CR' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                onClick={() => setInvestment('70L-1CR')}
                            >
                                <input
                                    type="radio"
                                    name="invest"
                                    id=""
                                    className='accent-white'
                                    value={'70L-1CR'}
                                    checked={investement === '70L-1CR'}
                                />
                                <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>70L-1CR</label>
                            </div>
                        </div>
                    </div>

                    <div className={` flex flex-col font-medium position-relative`}>
                        <label className='sm:!text-lg text-base !mb-3 '>Purpose of Purchase?</label>
                        <div className='flex gap-6'>
                            <div
                                className={`w-max rounded-full flex items-center text-lg border ${purpose === 'end use' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5] ' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                onClick={() => setPurpose('end use')}
                            >
                                <input
                                    type="radio"
                                    name="Purpose"
                                    value={'end use'}
                                    id=""
                                    className='accent-white'
                                    checked={purpose === 'end use'}

                                />
                                <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>End Use</label>
                            </div>
                            <div
                                className={`w-max rounded-full flex items-center text-lg border ${purpose === 'investment' ? 'text-white bg-gradient-to-r from-[#684EFB] to-[#3B37F5]' : ' bg-[#F2F3F6] text-[#666677]'}  px-4 md:!px-6 py-2 md:!py-4`}
                                onClick={() => setPurpose('investment')}
                            >
                                <input type="radio"
                                    name="Purpose"
                                    value={'investment'}
                                    id=""
                                    className='accent-white'
                                    checked={purpose === 'investment'}
                                />
                                <label className='ml-1.5 sm:ml-2.5 text-sm sm:text-base font-semibold mb-0'>Investment</label>
                            </div>
                        </div>
                    </div>

                    <div className='w-full flex flex-col-reverse sm:flex-row items-center sm:space-x-6 space-y-reverse space-y-4 sm:space-y-0'>

                        <button className='w-full sm:w-1/2 text-base sm:!text-lg border rounded-xl !py-2  sm:!py-3.5' onClick={() => {
                            setChannelPartner('2')
                        }}>Back</button>
                        <button className='w-full sm:w-1/2 text-base sm:!text-lg rounded-xl !py-2  sm:!py-3.5 bg-blue-900 text-white' onClick={() => {
                            handleSubmit()
                        }}>Next</button>

                    </div>
                </div>

            </div>

        </div>
    )
}

export default CustomerDetails